<template>
    <div>
        <b-modal
            id="confirm_redeem_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline" v-html="headline"></p>
                </div>
                <div class="modal-base-body">
                    <p id="message" v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <div class="col-btn wrapper-btn-cancel">
                        <div class="btn btn-secondary btn-cancel" @click="clickCloseConfirmRedeem()">{{lblConfirmRedeem.cancel}}</div>
                    </div>
                    <div class="col-btn wrapper-btn-confirm">
                        <div class="btn btn-primary btn-confirm" @click="clickConfirmRedeem()">{{lblConfirmRedeem.confirm}}</div>
                    </div>


                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    name: 'ConfirmRedeemModal',
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object
    },
    data: function () {
        return {
            headline: '',
            message: '',

            lblConfirmRedeem: {},
            lblDate: {}
        };
    },
    mounted: function () {
        this.lblDate = this.lbl.date;
        this.lblConfirmRedeem = this.lbl.confirm_redeem;
        this.busModal.$on('showConfirmRedeemModal', this.initialConfirmModal);
        this.busModal.$on('hideConfirmRedeemModal', this.closeConfirmModal);
    },
    methods: {
        //Event
        clickConfirmRedeem: function () {
            this.$emit('clickConfirmRedeem');
            this.closeConfirmModal();
        },
        clickCloseConfirmRedeem: function () {
            var label = this.campaign.id + "|" + this.campaign.name;
            var gtm = {
                 "event_label": this.campaign.name,
                 "privilege_category_name": this.campaign.categoryName,
                 "privilege_id": this.campaign.id,
                 "timestamp": Moment().format("YYYYMMDD HH:mm:ss")
            };
            Vue.ga.event(this, "privilege", "cancel_redeem_step1", label, null, gtm);
            this.closeConfirmModal();
        },
        //Function
        initialConfirmModal: function () {

            Vue.ga.screenName(this, "privilege_redeem");
            var label = this.campaign.id + "|" + this.campaign.name;
            Vue.ga.event(this, "privilege_redeem", "click_campaign", label);

            var minute = this.campaign.minutesValidAfterUsed;
            var isDelivered = false;
            var haveTimer = false;

            if(this.campaign.delivered) isDelivered = true;
            if(this.campaign.minutesValidAfterUsed
                || this.campaign.minutesValidAfterUsed > 0) haveTimer = true;

            this.headline = this.lblConfirmRedeem.headline;
            this.message = this.lblConfirmRedeem.free_no_timer;

            switch(this.campaign.type) {
                case Vue.CampaignType.Draw:
                    this.message = isDelivered
                        ? this.lblConfirmRedeem.draw_delivery
                        : this.getDrawMessage(this.lblConfirmRedeem.draw);
                    break;
                case Vue.CampaignType.Free:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.free_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.free_no_timer;
                    }
                    break;
                case Vue.CampaignType.Deal:
                    if(isDelivered) {
                        this.message = this.lblConfirmRedeem.deal_delivery;
                    } else {
                        this.message = haveTimer
                            ? this.getTimerMessage(this.lblConfirmRedeem.free, minute)
                            : this.lblConfirmRedeem.deal_no_timer;
                    }
                    break;
                case Vue.CampaignType.Buy:
                    this.message = this.lblConfirmRedeem.buy;
                    break;
                case Vue.CampaignType.Interface:
                    this.message = this.lblConfirmRedeem.interface;
                    break;
                default:
                    break;
            }

            this.message = this.lblConfirmRedeem.free_no_timer;


            this.$bvModal.show('confirm_redeem_modal');

        },
        closeConfirmModal: function () {


            //Vue.ga.event(this, "privilege_cancel_redeem", "click_campaign", label);

            this.$bvModal.hide('confirm_redeem_modal');
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    #headline {
        text-align: center;
        font-size: 28px;
        font-weight: bold;
    }

    #message {
        font-size: 22px;
        font-weight: 500;
        line-height: 1;
        text-align: center;
        padding: 15px 0;
    }

    .modal-base-footer {
        display: flex;
        width: 100%;

        .col-btn {
            width: 50%;
            display: flex;
            &.wrapper-btn-cancel {
                padding-right: 7.5px;
                .btn-cancel {
                    width: 100%;
                    font-size: 23px;
                    background-color: $background-gray-btn-cancel-color;
                    color: white;
                    border: 0;

                }
            }
            &.wrapper-btn-confirm {
                padding-left: 7.5px;
                .btn-confirm {
                    width: 100%;
                    color: white;
                    border: 0;
                    font-size: 23px;
                    background-image: url('../../assets/campaign/button_redeem@2x.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                }
            }
        }
    }



</style>
<style lang="scss">
    #confirm_redeem_modal {
        .modal-dialog {
            padding: 0 15px;
            .modal-content {
                border-radius: 15px;
            }
        }
    }
</style>
